import { render, staticRenderFns } from "./forum-like.vue?vue&type=template&id=d2b8d808&"
import script from "./forum-like.vue?vue&type=script&lang=js&"
export * from "./forum-like.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports